// extracted by css-extract-rspack-plugin
module.exports =  {"commentWidgetWrappper":"JLWhg","commentIcon":"QCLLN"};